// extracted by mini-css-extract-plugin
export default {"wrapper":"completeform_wrapper__Ps7yO","imageWrapper":"completeform_imageWrapper__qloDQ","right":"completeform_right__5aWwS","inputWrapper":"completeform_inputWrapper__hrCh4"};